var exports = {
  "JC": "UserProfilePopout.module__role___VzE1VE",
  "s$": "UserProfilePopout.module__roleRemoveIcon___VzE1VE",
  "Bx": "UserProfilePopout.module__iconSmall___VzE1VE",
  "bc": "UserProfilePopout.module__profileCustomStatus___VzE1VE",
  "CQ": "UserProfilePopout.module__profileCustomStatusText___VzE1VE",
  "ZB": "UserProfilePopout.module__profileDisplayName___VzE1VE",
  "yn": "UserProfilePopout.module__profileDataWarning___VzE1VE",
  "zF": "UserProfilePopout.module__profilePopoutCard___VzE1VE",
};

module.exports = exports;
